import { createPortal } from "react-dom";
import { AlertTriangle, ChevronDown, Clock3 } from "lucide-react";

export type OperatorNoticeData = {
  tone: "error" | "warning" | "information";
  title: string;
  detail: string;
  compact?: boolean;
  actionLabel?: string;
  actionDisabled?: boolean;
  onAction?: () => void;
};

// One surface, in priority order: failed action, stale data, changed work,
// active carryover, then plan timing. Dismissing a message never changes a run.
export function chooseOperatorNotice(...notices: Array<OperatorNoticeData | null>): OperatorNoticeData | null {
  return notices.find(notice => notice !== null) ?? null;
}

export function OperatorNotice({ notice, inline = false }: { notice: OperatorNoticeData | null; inline?: boolean }) {
  if (!notice) return null;
  const Icon = notice.tone === "warning" ? Clock3 : AlertTriangle;
  const content = <section className={`operator-notice tone-${notice.tone}${inline ? " is-inline" : ""}`} role={notice.tone === "error" ? "alert" : "status"} aria-atomic="true">
    <Icon size={20} aria-hidden="true" />
    {notice.compact ? <details className="operator-notice-detail"><summary aria-label={`${notice.title} — ayrıntıyı aç veya kapat`}><strong>{notice.title}</strong><ChevronDown size={16} aria-hidden="true" /></summary><p>{notice.detail}</p></details> : <div className="operator-notice-detail"><strong>{notice.title}</strong><p>{notice.detail}</p></div>}
    {notice.onAction ? <button type="button" disabled={notice.actionDisabled} onClick={notice.onAction}>{notice.actionLabel}</button> : null}
  </section>;
  return inline || typeof document === "undefined" ? content : createPortal(content, document.body);
}
